<!--
 * @Author: your name
 * @Date: 2019-10-24 20:32:55
 * @Description: In User Settings Edit
 -->
<template>
  <div>
    <el-dialog lock-scroll :modal-append-to-body="false"  :append-to-body="true" :title="$lang('编辑订单')" custom-class="j-dialog"
      :close-on-click-modal="false" top="45px" :visible.sync="visible" @close="close" width="960px">
      <div class="overflow">
        <el-form class="el-form-edit" ref="orderForm" :rules="rules" :inline="true" :model="formData" label-position="left"
          label-suffix=" :">
          <!-- <div class="group-title" style="padding:0 0 16px 0;" v-show="comeFrom==='order'">
            <span class="title">寄件人信息</span>
          </div> -->
          <h3 v-show="comeFrom==='order'">{{$lang('寄件人信息')}}</h3>
          <div class="group-content" v-show="comeFrom==='order'">
            <el-form-item :label="$lang('姓名')" prop="senderName">
              <el-input v-model="formData.senderName" :placeholder="$lang('请输入')" :minlength="1" :maxlength="60"></el-input>
            </el-form-item>
            <el-form-item class="area-code" label-width="50px"  :label="$lang('区号')">
              <el-button plain>+52</el-button>
            </el-form-item>
            <el-form-item :label="$lang('联系电话')" prop="senderMobilePhone">
              <el-input v-model="formData.senderMobilePhone" :placeholder="$lang('请输入')" :maxlength='15'></el-input>
            </el-form-item>
            <!-- <el-form-item :label="$lang('省/市/区')" prop="senderProvince">
              <BaseAddress ref="senderProvinceSearch" :showLevel="3" :initAddressData="sendAddressData" v-model="formData.senderProvince">
              </BaseAddress>
            </el-form-item> -->
            <el-form-item :label="$lang('公司名称')" prop="senderCompany">
              <template slot="label"><span :title="$lang('公司名称')">{{$lang('公司名称')}}</span></template>
              <el-input v-model="formData.senderCompany" :placeholder="$lang('请输入公司名称')"  :minlength="1"  :maxlength="256" />
            </el-form-item>
            <el-form-item :label="$lang('邮箱')" id="areaCodeSty" prop="senderEmail">
                <el-input v-model.trim="formData.senderEmail" :minlength="1"  :maxlength="30"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('邮编')" id="areaCodeSty" prop="senderPostalCode">
                <el-input v-model.trim="formData.senderPostalCode" :minlength="1" :maxlength="5" @blur="postalCodeChange(formData.senderPostalCode, 1, 'formData')"></el-input>
            </el-form-item>
            <!-- <el-form-item :label="$lang('省/市/区')" prop="senderProvince">
                <BaseAddress ref="senderProvinceSearch" :initAddressData="sendAddressData"
                :showLevel="3" v-model="formData.senderProvince"> </BaseAddress>
            </el-form-item> -->

            <el-form-item :label="$lang('州')" prop="senderProvinceName">
              <el-input v-model.trim="formData.senderProvinceName" readonly></el-input>
              <!-- <el-select v-model="formData.senderProvinceName" @change="dataProvinceChange($event, 1)">
                <el-option
                  v-for="item in provinceList"
                  :key="item.id"
                  :label="item.nativeName"
                  :value="item.id"
                />
              </el-select> -->
            </el-form-item>
            <el-form-item :label="$lang('市')" prop="senderCityName">
              <el-input v-model.trim="formData.senderCityName" readonly></el-input>
              <!-- <el-select v-model="formData.senderCityName" @change="dataCityChange($event, 1)">
                <el-option
                  v-for="item in cityList"
                  :key="item.id"
                  :label="item.nativeName"
                  :value="item.id"
                />
              </el-select> -->
            </el-form-item>
            <el-form-item :label="$lang('乡镇')" prop="senderAreaName">
              <el-select v-model="formData.senderAreaName" @change="dataAreaChange($event, 1)">
                <el-option
                  v-for="item in areaList"
                  :key="item.id"
                  :label="item.nativeName"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item class="el-form-item item-col-3 el-form-item--small w360" :label="$lang('详细地址')" prop="senderDetailedAddress">
              <el-input v-model="formData.senderDetailedAddress" :placeholder="$lang('请输入')" :minlength="4" :maxlength="256"></el-input>
            </el-form-item>
            <el-form-item class="el-form-item w360 el-form-item--small" :label="$lang('详细地址2')" prop="senderAlternateAddress">
              <el-input v-model="formData.senderAlternateAddress" :placeholder="$lang('请填写寄件人所在街道以及详细地址')" :minlength="1"  :maxlength="256" ></el-input>
          </el-form-item>
          </div>
          <!-- <div class="group-title">
            <span class="title">收件人信息</span>
          </div> -->
          <h3>{{$lang('收件人信息')}}</h3>
          <div class="group-content">
            <el-form-item :label="$lang('姓名')" prop="receiverName">
              <el-input v-model="formData.receiverName" :placeholder="$lang('请输入')" :minlength="1" :maxlength="60"></el-input>
            </el-form-item>
             <el-form-item class="area-code" label-width="50px" :label="$lang('区号')">
              <el-button plain>+52</el-button>
            </el-form-item>
            <el-form-item :label="$lang('联系电话')" prop="receiverMobilePhone">
              <el-input v-model="formData.receiverMobilePhone" :placeholder="$lang('请输入')" :maxlength='15'></el-input>
            </el-form-item>
            <!-- <el-form-item :label="$lang('省/市/区')" prop="receiverProvince">
              <BaseAddress ref="receiverProvinceSearch" :showLevel="3" :initAddressData="receiverAddressData"
                v-model="formData.receiverProvince"> </BaseAddress>
            </el-form-item> -->
             <el-form-item :label="$lang('公司名称')" prop="receiverCompany">
              <template slot="label"><span :title="$lang('公司名称')">{{$lang('公司名称')}}</span></template>
              <el-input v-model="formData.receiverCompany" :placeholder="$lang('请输入公司名称')"  :minlength="1"  :maxlength="256" />
            </el-form-item>
            <el-form-item :label="$lang('邮箱')" id="areaCodeSty" prop="receiverEmail">
                <el-input v-model.trim="formData.receiverEmail" :minlength="1"  :maxlength="30"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('邮编')" id="areaCodeSty" prop="receiverPostalCode">
                <el-input v-model.trim="formData.receiverPostalCode" :minlength="1" :maxlength="5" @blur="postalCodeChange(formData.receiverPostalCode, 2, 'formData')"></el-input>
            </el-form-item>
            <!-- <el-form-item :label="$lang('省/市/区')" prop="receiverProvince">
                <BaseAddress ref="receiverProvinceSearch" :initAddressData="receiverAddressData" :showLevel="3" v-model="formData.receiverProvince"> </BaseAddress>
            </el-form-item> -->
            <el-form-item :label="$lang('州')" prop="receiverProvinceName">
              <el-input v-model.trim="formData.receiverProvinceName" readonly></el-input>
              <!-- <el-select v-model="formData.receiverProvinceName" @change="dataProvinceChange($event, 2)">
                <el-option
                  v-for="item in provinceList"
                  :key="item.id"
                  :label="item.nativeName"
                  :value="item.id"
                />
              </el-select> -->
            </el-form-item>
            <el-form-item :label="$lang('市')" prop="receiverCityName">
              <el-input v-model.trim="formData.receiverCityName" readonly></el-input>
              <!-- <el-select v-model="formData.receiverCityName" @change="dataCityChange($event, 2)">
                <el-option
                  v-for="item in cityList2"
                  :key="item.id"
                  :label="item.nativeName"
                  :value="item.id"
                />
              </el-select> -->
            </el-form-item>
            <el-form-item :label="$lang('乡镇')" prop="receiverAreaName">
              <el-select v-model="formData.receiverAreaName" @change="dataAreaChange($event, 2)">
                <el-option
                  v-for="item in areaList2"
                  :key="item.id"
                  :label="item.nativeName"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item class="el-form-item item-col-3 el-form-item--small w360" :label="$lang('详细地址')" prop="receiverDetailedAddress">
              <el-input v-model="formData.receiverDetailedAddress" :placeholder="$lang('请输入')" :minlength="1" :maxlength="256"></el-input>
            </el-form-item>
                 <el-form-item class="el-form-item w360 el-form-item--small" :label="$lang('详细地址2')" prop="receiverAlternateAddress">
              <el-input v-model="formData.receiverAlternateAddress" :placeholder="$lang('请填写收件人所在街道以及详细地址')" :minlength="1"  :maxlength="256" ></el-input>
          </el-form-item>
          </div>
          <!-- <div class="group-title">
            <span class="title">货物信息</span>
          </div> -->
          <h3>{{$lang('货物信息')}}</h3>
             <div class="group-content">
          <el-form-item :label="$lang('物品类型')" prop="goods">
            <Base-Select v-model="formData.goods" :props="{label:'name',value:'code', res:'appArticleTypeVOList',valueObj:true}"
              dicUrl="/vip/baseData/list" :placeholder="$lang('请选择')"></Base-Select>
          </el-form-item>
          <el-form-item :label="$lang('物品名称')" prop="goodsName">
            <el-input v-model="formData.goodsName" :placeholder="$lang('请输入')" :minlength="1" :maxlength="20"></el-input>
          </el-form-item>
          <el-form-item :label="$lang('物品件数')" prop="packageNumber">
            <el-input v-model="formData.packageNumber" :placeholder="$lang('请输入')" :minlength="1" :maxlength="3"></el-input>
          </el-form-item>
          <el-form-item :label="$lang('净重')" prop="netWeight">
            <el-input-number v-model="formData.netWeight" :label="$lang('描述文字')" :precision="2" :min="0" :max="30"></el-input-number>
          </el-form-item>
          <el-form-item :label="$lang('包裹重')" prop="packageTotalWeight">
            <el-input-number v-model="formData.packageTotalWeight" :label="$lang('描述文字')" :precision="2" :min="0" :max="30"></el-input-number>
          </el-form-item>
          <!-- <el-form-item :label="$lang('物品件数')" prop="packageNumber">
            <el-input-number v-model="formData.packageNumber" label="描述文字" :step="1" :precision="0" :min="0" :max="999"></el-input-number>
          </el-form-item> -->
          <!-- <el-form-item :label="$lang('产品类型')" prop="payType">
            <Base-Select v-model="formData.payType" :dic="DIC.payType" :placeholder="$lang('请选择')"></Base-Select>
          </el-form-item> -->
          <el-form-item :label="$lang('结算方式')" prop="payment">
               <Base-Select v-model="formData.payment" :props="{label:'name',value:'code', res:'appPaymentMannerVOList',valueObj:true}"
                    dicUrl="/vip/baseData/list"  :placeholder="$lang('请选择')">
                </Base-Select>
            <!-- <Base-Select v-model="formData.payment" :dic="DIC.payTypes" :placeholder="$lang('请选择')"
              :props="{label:'name',value:'code',valueObj:true}"></Base-Select> -->
          </el-form-item>
           <el-form-item :label="$lang('快递类型')" prop="expressType">
                <Base-Select v-model="formData.expressType" :props="{label:'name',value:'code', res:'appProductTypeVOList',valueObj:true}"
                    dicUrl="/vip/baseData/list"  :placeholder="$lang('请选择')">
                </Base-Select>
            </el-form-item>
          <el-form-item :label="$lang('参考运费')" prop="standardValue" v-if="this.user.freightStatus === 1">
            <el-input v-model="formData.standardValue" disabled></el-input>
          </el-form-item>
          <!-- <el-form-item :label="$lang('箱材规格')" prop="boxStandard">
            <Base-Select v-model="formData.boxStandard" :props="{label:'name',value:'id', res:'records',valueObj:true}"
              dicUrl="/vip/material/getMaterialSalesPrice" :placeholder="$lang('请选择')" @change="changeBoxStandard">
            </Base-Select>
          </el-form-item> -->
          <!-- <el-form-item label="箱子数量" prop="boxNumber">
            <el-input-number v-model="formData.boxNumber"  :step="1" :precision="0" :min="0" :max="99"></el-input-number>
          </el-form-item> -->
          <!-- <el-form-item label="箱子单价">
            <el-input v-model="formData.boxPrice" disabled></el-input>
          </el-form-item> -->
          <el-form-item :label="$lang('客户订单号')" prop="customerOrderId">
            <el-input
                v-model="formData.customerOrderId"
                :placeholder="$lang('请输入')"
                :minlength="1"
                :maxlength="50"
                :disabled="isCustomerLabelDisabled"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$lang('是否保价')" prop="insured" class="insured-info">
            <Base-Select v-model="formData.insured" :clearable="false" :dic="DIC.insured" :placeholder="$lang('请选择')"  :disabled="paymentOption"  @change="changeInsured" :props="{label:'name' ,value:'code'}"></Base-Select>
            <div>
              <a class="btn_insured_myself" @click="openInsured">{{$lang('保价声明')}}</a>
            </div>
          </el-form-item>
          <el-form-item :label="$lang('物品价值')" prop="declaredValue" v-show="formData.insured === 1" class="declaredValue">
            <el-input-number v-model="formData.declaredValue" :placeholder="$lang('请输入')" :step="1" :precision="2" :controls="false" :min="0" :max="100000"></el-input-number>
          </el-form-item>
          <el-form-item :label="$lang('保价费')" prop="insuredValue" v-show="formData.insured===1">
            <el-input v-model="formData.insuredValue" :placeholder="$lang('请输入')" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item :label="$lang('燃油附加费')" prop="fuelCost" class="declaredValue" v-if="this.user.freightStatus === 1">
            <el-input-number v-model="formData.fuelCost" :disabled="true" :placeholder="$lang('请输入')" :step="1" :precision="3" :controls="false" :min="0" :max="100000"></el-input-number>
          </el-form-item>
          <el-form-item :label="$lang('增值税')" prop="fuelVat" class="declaredValue" v-if="this.user.freightStatus === 1">
            <el-input-number v-model="formData.fuelVat" :disabled="true" :placeholder="$lang('请输入')" :step="1" :precision="3" :controls="false" :min="0" :max="100000"></el-input-number>
          </el-form-item>
          <el-form-item :label="$lang('总运费')" prop="totalFreight" class="declaredValue" v-if="this.user.freightStatus === 1">
            <el-input-number v-model="formData.totalFreight" :disabled="true" :placeholder="$lang('请输入')" :step="1" :precision="3" :controls="false" :min="0" :max="100000"></el-input-number>
          </el-form-item>
          <br>
          <el-form-item :label="$lang('备注')" prop="remarks" style="width:860px;">
            <el-input type="textarea" v-model="formData.remarks" :maxlength="256" :label="$lang('描述文字')" show-word-limit></el-input>
          </el-form-item>
             </div>
        </el-form>
      </div>
      <div class="dialog-footer">
        <!-- <el-button @click="close">{{ $lang('取消') }}</el-button> -->
        <el-button type="primary" :loading="keyBtn" @click="sumbit" class="h40">{{ $lang('保 存') }}</el-button>
      </div>
      <InsuredStatement :infoVisible="infoVisible" @closeInsured="closeInsured"></InsuredStatement>
    </el-dialog>
  </div>
</template>

<script>
import { DIC } from '@constants'
import { mapGetters } from 'vuex'
import { RULES, phoneAndMobile, integerWeight, isNullObj } from '@utils/rules'
import * as Api from '@api/base/public'
import { getComCost, getSettlement, getComputationCost, getfuelCost } from '@api/module/customer'
import InsuredStatement from '@components/dialog/InsuredStatement'
import debounce from 'lodash/debounce'
import address from '@/mixins/address'

export default {
  name: 'EditOrder',
  mixins: [address],
  components: {
    InsuredStatement
  },
  props: {
    value: {},
    orderData: {
      type: Object,
      default: function() {
        return {}
      }
    },
    comeFrom: {
      type: String,
      default: function() {
        return 'order'
      }
    },
    disablePayment: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      DIC,
      keyBtn: false,
      data: '',
      visible: false,
      infoVisible: false, // 保价费声明弹窗
      paymentOption: false,
      formData: {
        senderName: '', // 寄件人姓名,
        senderMobilePhone: '', // 寄件人手机号,
        senderProvince: {},
        senderProvinceId: '', // 寄件省份id,
        senderProvinceName: '', // 寄件省份名称,
        senderCityId: '', // 寄件城市id,
        senderCityName: '', // 寄件城市名称,
        senderAreaId: '', // 寄件区域id,
        senderAreaName: '', // 寄件区域名称,
        senderLocal: '', // 寄件区省/市/区
        senderDetailedAddress: '', // 寄件详细地址,
        senderAlternateAddress: '',
        senderCompany: '',
        senderPostalCode: '',
        senderEmail: '',
        receiverName: '', // 收件人姓名,
        receiverMobilePhone: '', // 收件人手机号,
        receiverProvince: {},
        receiverProvinceId: '', // 收件省份id,
        receiverProvinceName: '', // 收件省份名称,
        receiverCityId: '', // 收件城市id,
        receiverCityName: '', // 收件城市名称,
        receiverAreaId: '', // 收件区域id,
        receiverAreaName: '', // 收件区域名称,
        receiverLocal: '', // 收件区省/市/区
        receiverDetailedAddress: '', // 收件详细地址,
        receiverAlternateAddress: '',
        receiverEmail: '',
        receiverPostalCode: '',
        receiverCompany: '',
        insured: 0, // 是否保价1是，0否,
        declaredValue: '', // 物品价值,
        insuredValue: '', // 保价费,
        goods: '', // 物品类型
        goodsTypeId: '', // 物品类型id,
        goodsTypeCode: '', // 物品类型编码,
        goodsTypeName: '', // 物品类型名称,
        goodsName: '', // 物品名称,
        packageTotalWeight: 0, // 包裹重,
        netWeight: 0,
        packageNumber: 1, // 物品件数,
        payment: '', // 支付方式
        paymentModeId: '', // 支付方式id,
        paymentModeCode: '', // 支付方式编码,
        paymentModeName: '', // 支付方式名称,
        expressType: '', // 快递类型
        expressTypeCode: '', // 快递类型code
        expressTypeName: '', // 快递类型name
        codMoney: '', // COD,
        codFee: 0, // COD手续费,
        standardValue: 0, // 参考运费,
        boxNumber: 1, // 箱材数量,
        boxStandard: '', // 箱材规格
        boxStandardId: '', // 箱材规格id,
        boxStandardCode: '', // 箱材规格编码,
        boxStandardName: '', // 箱材规格名称,
        boxPrice: 0, // 箱材单价,
        remarks: '', // 备注,
        settlementWeight: 0, // 结算重量
        packageChargeWeight: 1, // 结算重量,
        customerOrderId: '',
        fuelCost: 0, // 燃油附加费
        fuelVat: 0, // 增值税
        totalFreight: 0 // 总运费
      },
      rules: {},
      sendAddressData: {
        formProps: {
          provinceIdProp: 'provinceId',
          provinceNameProp: 'provinceName',
          cityIdProp: 'cityId',
          cityNameProp: 'cityName',
          areaIdProp: 'areaId',
          areaNameProp: 'areaName'
        },
        defaultData: {}
      },
      receiverAddressData: {
        formProps: {
          provinceIdProp: 'provinceId',
          provinceNameProp: 'provinceName',
          cityIdProp: 'cityId',
          cityNameProp: 'cityName',
          areaIdProp: 'areaId',
          areaNameProp: 'areaName'
        },
        defaultData: {}
      },
      startAddressId: null,
      endAddressId: null,
      areaList: [],
      areaList2: []
    }
  },
  watch: {
    comeFrom: {
      handler(val) {
        if (val === 'order') {
          this.rules = {
            senderName: [RULES.requiredTrim, RULES.senderName],
            senderMobilePhone: [RULES.required, { validator: phoneAndMobile }],
            senderProvince: [RULES.requiredSelect],
            senderDetailedAddress: [RULES.required, RULES.senderCompany],
            senderCompany: [RULES.senderCompany],
            senderEmail: [RULES.email],
            senderPostalCode: [RULES.required, RULES.postalCode],
            senderAlternateAddress: [RULES.senderCompany],
            senderProvinceName: [RULES.requiredPostalCod],
            senderCityName: [RULES.requiredPostalCod],
            senderAreaName: [RULES.requiredSelect],
            receiverName: [RULES.requiredTrim, RULES.senderName],
            receiverMobilePhone: [RULES.required, { validator: phoneAndMobile }],
            receiverProvince: [RULES.requiredSelect, { validator: isNullObj }],
            receiverDetailedAddress: [RULES.required, RULES.senderCompany],
            receiverAlternateAddress: [RULES.senderCompany],
            receiverCompany: [RULES.senderCompany],
            receiverEmail: [RULES.email],
            receiverPostalCode: [RULES.required, RULES.postalCode],
            receiverProvinceName: [RULES.requiredPostalCod],
            receiverCityName: [RULES.requiredPostalCod],
            receiverAreaName: [RULES.requiredSelect],
            goods: [RULES.requiredSelect],
            // goodsName: [RULES.required, { validator: checkGoodsName }],
            packageTotalWeight: [RULES.required, { validator: integerWeight }],
            netWeight: [RULES.required, { validator: integerWeight }],
            payment: [RULES.requiredSelect],
            expressType: [RULES.required, RULES.requiredSelect],
            insured: [RULES.requiredSelect],
            packageNumber: [RULES.required, RULES.stopSellTime]
          }
        } else {
          this.rules = {
            receiverName: [RULES.requiredTrim, RULES.senderName],
            receiverMobilePhone: [RULES.requiredTrim, { validator: phoneAndMobile }],
            receiverProvince: [RULES.requiredSelect, { validator: isNullObj }],
            receiverDetailedAddress: [RULES.required, RULES.senderCompany],
            receiverAlternateAddress: [RULES.senderCompany],
            receiverCompany: [RULES.senderCompany],
            receiverEmail: [RULES.email],
            receiverPostalCode: [RULES.required, RULES.postalCode],
            receiverProvinceName: [RULES.requiredPostalCod],
            receiverCityName: [RULES.requiredPostalCod],
            receiverAreaName: [RULES.requiredSelect],
            goods: [RULES.requiredSelect],
            packageTotalWeight: [RULES.required, { validator: integerWeight }],
            netWeight: [RULES.required, { validator: integerWeight }],
            payment: [RULES.requiredSelect],
            expressType: [RULES.required, RULES.requiredSelect],
            insured: [RULES.requiredSelect],
            packageNumber: [RULES.required, RULES.stopSellTime]
          }
        }
      },
      immediate: true
    },
    value: {
      handler(val) {
        this.visible = val
      },
      immediate: true
    },
    orderData: {
      handler(val) {
        // 箱材规格 初始化
        const boxStandard = {
          id: val.boxStandardId,
          materialCode: val.boxStandardCode,
          materialName: val.boxStandardName,
          boxPrice: val.boxPrice,
          salesPrice: val.boxPrice,
          name: val.boxStandardName,
          code: val.boxStandardCode
        }
        const goods = {
          id: val.goodsTypeId,
          code: val.goodsTypeCode,
          name: val.goodsTypeName
        }
        const payment = {
          id: val.paymentModeId,
          code: val.paymentModeCode,
          name: val.paymentModeName
        }
        const expressType = {
          code: val.expressTypeCode, // 快递类型code
          name: val.expressTypeName // 快递类型name
        }
        // 去掉是否保价默认值
        this.formData = Object.assign(this.formData, val, { boxStandard }, { goods }, { payment }, { expressType })
        this.handleProvice(this.formData)
        // 初始化 箱材规格
      },
      deep: true
    },
    // 物品类型
    async 'formData.goods'(val) {
      const { id: goodsTypeId, code: goodsTypeCode, name: goodsTypeName } = val || {}
      Object.assign(this.formData, { goodsTypeId, goodsTypeCode, goodsTypeName })
      const { declaredValue, goods, insured } = this.formData
      if (insured === 1 && goods && parseFloat(declaredValue) > 0) {
        const res = await this.getComputationCost(this.formData)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = 0
      }
      if (goodsTypeName === '文件') {
        Object.assign(this.formData, { insured: 0, declaredValue: '' })
        this.formData.insuredValue = 0
      }
      this.calcStandardCostBefore()
    },
    // 支付方式
    async 'formData.payment'(val) {
      const { id: paymentModeId, code: paymentModeCode, name: paymentModeName } = val || {}
      if (val.code === 'CC_CASH') {
        this.paymentOption = true
        Object.assign(this.formData, { insured: 0, declaredValue: '' })
      } else {
        this.paymentOption = false
        // this.formData.declaredValue = ''
      }
      Object.assign(this.formData, { paymentModeId, paymentModeCode, paymentModeName })
      this.calcStandardCostBefore()
      // const { senderProvinceId, receiverProvinceId, packageTotalWeight } = this.formData
      // if (senderProvinceId && receiverProvinceId && val && packageTotalWeight > 0) {
      //   const res = await this.calcStandardCost(this.formData)
      //   Object.assign(this.formData, res)
      // }
      // 到付现结不支持保价
      if (val.name === '到付现结') {
        Object.assign(this.formData, { insured: 0, declaredValue: '', signReceipt: 0 })
        this.formData.insuredValue = 0
        this.formData.receiptFreight = 0
      }
      console.log(this.formData)
    },

    async 'formData.standardValue' (val) {
      console.log(val)
      const { standardValue, insuredValue } = this.formData
      try {
        const { code, msg, data } = await getfuelCost()
        if (data && (data.fuelSurcharge || data.vat)) {
          this.fuelSurcharge = data.fuelSurcharge ? parseFloat(data.fuelSurcharge) : 0
          this.vatChange = data.vat ? parseFloat(data.vat) : 0
          console.log(code + msg + data)
          this.formData.fuelCost = this.checkCost(parseFloat(standardValue), parseFloat(insuredValue), this.fuelSurcharge, -1)
          this.formData.fuelVat = this.checkCost(parseFloat(standardValue), parseFloat(insuredValue), this.vatChange, parseFloat(this.formData.fuelCost))
        } else {
          Object.assign(this.formData, { fuelCost: 0, fuelVat: 0 })
        }
        this.$nextTick(_ => {
          this.formData.totalFreight = parseFloat(standardValue) + parseFloat(this.formData.fuelCost) + parseFloat(this.formData.fuelVat)
        })
      } catch (error) {
        // this.keyBtn1 = false
      }
    },

    async 'formData.insuredValue' (val) {
      console.log(val)
      const { standardValue, insuredValue } = this.formData
      try {
        const { code, msg, data } = await getfuelCost()
        if (data && (data.fuelSurcharge || data.vat)) {
          this.fuelSurcharge = data.fuelSurcharge ? parseFloat(data.fuelSurcharge) : 0
          this.vatChange = data.vat ? parseFloat(data.vat) : 0
          console.log(code + msg + data)
          this.formData.fuelCost = this.checkCost(parseFloat(standardValue), parseFloat(insuredValue), this.fuelSurcharge, -1)
          this.formData.fuelVat = this.checkCost(parseFloat(standardValue), parseFloat(insuredValue), this.vatChange, parseFloat(this.formData.fuelCost))
        } else {
          Object.assign(this.formData, { fuelCost: 0, fuelVat: 0 })
        }
        this.$nextTick(_ => {
          this.formData.totalFreight = parseFloat(standardValue) + parseFloat(this.formData.fuelCost) + parseFloat(this.formData.fuelVat)
        })
      } catch (error) {
        // this.keyBtn1 = false
      }
    },

    // // 支付方式
    // async 'formData.payment'(val) {
    //   const { id: paymentModeId, code: paymentModeCode, name: paymentModeName } = val
    //   Object.assign(this.formData, { paymentModeId, paymentModeCode, paymentModeName })
    //   const { senderProvinceId, receiverProvinceId, packageTotalWeight } = this.formData
    //   if (senderProvinceId && receiverProvinceId && val && packageTotalWeight > 0) {
    //     const res = await this.calcStandardCost(this.formData)
    //     Object.assign(this.formData, res)
    //   }
    //   // 到付现结不支持保价
    //   if (val.name === '到付现结') {
    //     Object.assign(this.formData, { insured: 0, declaredValue: '', signReceipt: 0 })
    //     this.formData.insuredValue = 0
    //     this.formData.receiptFreight = 0
    //   }
    //   console.log(this.formData)
    // },
    async 'formData.expressType'(val) {
      const { code, name } = val
      Object.assign(this.formData, { expressTypeCode: code, expressTypeName: name })
      this.calcStandardCostBefore()
    },
    // 运费计算
    // async 'formData.senderProvince'(val) {
    //   const obj = {
    //     senderProvinceId: val.provinceId,
    //     senderProvinceName: val.provinceName,
    //     senderCityId: val.cityId,
    //     senderCityName: val.cityName,
    //     senderAreaId: val.areaId,
    //     senderAreaName: val.areaName,
    //   }
    //   Object.assign(this.formData, obj)
    //   const { receiverProvince, packageTotalWeight } = this.formData
    //   if (receiverProvince && packageTotalWeight > 0) {
    //     const res = await this.calcStandardCost(this.formData)
    //     Object.assign(this.formData, res)
    //   }
    // },
    // 运费计算
    async 'formData.receiverProvince'(val) {
      this.calcStandardCostBefore()
      // const { receiverProvinceId, packageTotalWeight } = this.formData
      // const obj = {
      //   receiverProvinceId: val.provinceId,
      //   receiverProvinceName: val.provinceName,
      //   receiverCityId: val.cityId,
      //   receiverCityName: val.cityName,
      //   receiverAreaId: val.areaId,
      //   receiverAreaName: val.areaName,
      // }
      // Object.assign(this.formData, obj)
      // if (receiverProvinceId && packageTotalWeight > 0) {
      //   const res = await this.calcStandardCost(this.formData)
      //   Object.assign(this.formData, res)
      // }
    },
    // 运费计算
    async 'formData.senderAreaId'(val) {
      console.log('运费计算senderAreaId-------------', val, this.formData)
      this.calcStandardCostBefore()
      // const { receiverProvinceId, packageTotalWeight } = this.formData
      // if (receiverProvinceId && val && packageTotalWeight > 0) {
      //   const res = await this.calcStandardCost(this.formData)
      //   Object.assign(this.formData, res)
      // }
    },
    // 运费计算
    async 'formData.receiverAreaId'(val) {
      console.log('运费计算receiverAreaId-------------', val, this.formData)
      this.calcStandardCostBefore()
      // const { senderProvinceId, packageTotalWeight } = this.formData
      // if (senderProvinceId && val && packageTotalWeight > 0) {
      //   const res = await this.calcStandardCost(this.formData)
      //   Object.assign(this.formData, res)
      // }
    },
    // 包裹重
    async 'formData.packageTotalWeight'(val) {
      this.calcStandardCostBefore()
      // const { senderProvinceId, receiverProvinceId } = this.formData
      // if (senderProvinceId && receiverProvinceId && val > 0) {
      //   const res = await this.calcStandardCost(this.formData)
      //   Object.assign(this.formData, res)
      // }
    },
    // 保价费计算
    async 'formData.declaredValue'(val) {
      const { goods, insured } = this.formData
      if (insured === 1 && goods && parseFloat(val) > 0) {
        const res = await this.getComputationCost(this.formData)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = 0
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'user'
    }),
    isCustomerLabelDisabled() {
      // 客户标识customerLabel是否为1，为1则自动生成订单号不允许手工修改，反之可手工修改
      return this.user.customerLabel === '1'
    }
  },
  created() {
    if (this.formData.insured === 1) { // 是否保价1是，0否,
      this.rules.declaredValue = [RULES.required, RULES.declaredValue]
    }
  },
  mounted() {
    // this.calcStandardCost(this.formData)
    this.calcStandardCostBefore()
  },
  methods: {
    openInsured() {
      this.infoVisible = true
    },
    closeInsured() {
      this.infoVisible = false
    },
    async changeInsured(val) {
      this.formData.insured = val
      if (val === 0) {
        this.formData.insuredValue = 0
        this.formData.declaredValue = ''
      }
      const { goods, declaredValue } = this.formData
      if (val === 1 && goods && declaredValue && parseFloat(declaredValue)) {
        const res = await this.getComputationCost(this.formData)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = 0
      }
    },
    changeBoxStandard(val) {
      if (!val) {
        this.formData.boxPrice = 0
      }
      if (val && val.salesPrice) {
        const { id: boxStandardId, name: boxStandardName, salesPrice: boxPrice } = val
        Object.assign(this.formData, {
        // 箱材规格id
          boxStandardId,
          // 箱材规格名称
          boxStandardName,
          // 箱材单价
          boxPrice
        })
      }
    },
    sumbit() {
      if (this.formData.paymentModeId === 321 && this.formData.insured !== 0) {
        this.$message.error(this.$lang('到付件不支持保价'))
        return
      }
      if (this.formData.insured === 1 && (!this.formData.declaredValue || parseFloat(this.formData.declaredValue) <= 0)) {
        this.$message.error(this.$lang('物品价值必须大于0'))
        return
      }
      this.$emit('editSave', this.formData)
    },
    close() {
      this.$emit('editClose', false)
    },
    // 运费查询
    async calcStandardCostBefore() {
      const { goodsTypeCode, senderProvinceId, receiverProvinceId, packageTotalWeight, expressTypeCode, paymentModeCode } = this.formData
      if (senderProvinceId && receiverProvinceId && goodsTypeCode && packageTotalWeight > 0 && expressTypeCode && paymentModeCode) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
    },
    // 运费计算
    calcStandardCost: debounce(async function(data) {
      const { packageTotalWeight, paymentModeId } = data
      // const result = {
      //   // 寄件省份id
      //   senderProvinceId: senderProvince.provinceId,
      //   // 寄件省份名称
      //   senderProvinceName: senderProvince.provinceName,
      //   // 寄件城市id
      //   senderCityId: senderProvince.cityId,
      //   // 寄件城市名称
      //   senderCityName: senderProvince.cityName,
      //   // 寄件区域id
      //   senderAreaId: senderProvince.areaId,
      //   // 寄件区域名称
      //   senderAreaName: senderProvince.areaName,
      //   // 收件省份id
      //   receiverProvinceId: receiverProvince.provinceId,
      //   // 收件省份名称
      //   receiverProvinceName: receiverProvince.provinceName,
      //   // 收件城市id
      //   receiverCityId: receiverProvince.cityId,
      //   // 收件城市名称
      //   receiverCityName: receiverProvince.cityName,
      //   // 收件区域id
      //   receiverAreaId: receiverProvince.areaId,
      //   // 收件区域名称
      //   receiverAreaName: receiverProvince.areaName,
      // }
      const result = data
      // 运费
      const obj = {}
      if (result.senderAreaId && result.receiverAreaId) {
        const promises = [
        // 获取起始地址ID
          this.getSettlement(result.senderProvinceId, result.senderCityId, result.senderAreaId),
          // 获取目的地地址ID
          this.getSettlement(result.receiverProvinceId, result.receiverCityId, result.receiverAreaId)
        ]
        const [startAddressId, endAddressId] = await Promise.all(promises)
        // 如果起始地址且目的地地址ID存在
        if (startAddressId && endAddressId) {
          // 获取运费
          const res = await this.getComCost(packageTotalWeight, startAddressId, endAddressId, paymentModeId)
          obj.standardValue = res.result
          obj.settlementWeight = res.settValue
          this.formData.standardValue = res.result
        }
      }
      // 返回结果
      return {
        // ...result,
        ...obj
      }
    }, 200),
    // 211205，不再请求旧的区域列表接口，改用getSelectByZipCode接口获取
    async  handleProvice(row) {
      const { senderPostalCode, receiverPostalCode } = row
      if (this.comeFrom === 'order') {
        // 包含寄件人信息
        const promises = [
          // 获取寄件区域列表
          this.getSelectByZipCode(1, senderPostalCode),
          // 获取收件区域列表
          this.getSelectByZipCode(2, receiverPostalCode)
        ]
        const [areaList, areaList2] = await Promise.all(promises)
        this.areaList = areaList
        this.areaList2 = areaList2
      } else {
        // 不包含寄件人信息
        const promises = [
          // 获取收件区域列表
          this.getSelectByZipCode(2, receiverPostalCode)
        ]
        const [areaList2] = await Promise.all(promises)
        this.areaList2 = areaList2
      }
    },
    // 请求区域列表的方法
    async getSelectByZipCode(type, zipCode) {
      if (!zipCode) return []
      try {
        const res = await Api.getSelectByZipCode({ zipCode })
        if (res.succ) {
          if (!res.data) {
            // 不论查询寄件，收件，一律返回空数组
            return []
          } else {
            const { areaList = [] } = res.data || {}
            return areaList
          }
        } else {
          console.log(res.msg)
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 通过省市区匹配结算目的地(目的区域)
    async getSettlement(providerId, cityId, areaId, packageTotalWeight, type) {
      const reqData = { providerId, cityId, areaId }
      const { code, data } = await getSettlement(reqData)
      if (code === 1 && data) {
        const id = data.id
        return id
      } else {
        return ''
      }
    },
    // 运费计算
    async getComCost(number, startAddressId, endAddressId, paymentModeId) {
      let smMode = 2
      if (paymentModeId) {
        switch (paymentModeId) {
          case 6:
            smMode = 1
            break
          case 7:
            smMode = 2
            break
          case 8:
            smMode = 3
            break
        }
      }
      const { expressTypeCode, goodsTypeCode, senderCityId, receiverCityId } = this.formData
      const params = {
        value: number,
        startAddressId,
        endAddressId,
        smMode,
        productTypeCode: expressTypeCode,
        goodsTypeCode,
        startCityId: senderCityId,
        endCityId: receiverCityId
      }
      const { data = 0 } = await getComCost(params)
      return data || 0
    },
    // 保价费计算
    async getComputationCost(param) {
      // 参数
      const params = {
        // 物品价值
        value: param.declaredValue,
        // 物品类型code
        goodsTypeCode: param.goods.code
      }
      // 调用接口
      const { data } = await getComputationCost(params)
      return data || 0
    },
    // 燃油附加费与增值税计算
    checkCost(standardValue, insuredValue, percentage, type) {
      if ((standardValue !== 0 || insuredValue !== 0) && percentage !== 0) {
        if (type === -1) {
          var total1 = Math.round(((Number(standardValue) + Number(insuredValue)) * percentage) * 1000) / 1000
          return total1
        } else {
          var total2 = Math.round(((Number(standardValue) + Number(insuredValue) + Number(type)) * percentage) * 1000) / 1000
          return total2
        }
      } else {
        return 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.group-title {
  border-bottom: 1px dashed #eeeeee;
  // margin-bottom: 20px;
  margin: 0 10px 20px 10px;
  padding: 16px 0px;
  .title {
    font-size: 14px;
    color: #333;
    font-weight: 600;
    display: inline-block;
    line-height: 7px;
    border-bottom: 4px solid #e0bd7b;
  }
  .insert-info {
    display: inline-block;
    margin-left: 60px;
    position: relative;
    .icon {
      color: #e0bd7b;
      position: absolute;
      overflow: visible;
    }
    .text {
      color: #666666;
      margin-left: 20px;
    }
  }
}
.el-form-item {
  padding: 0px 8px 18px 8px !important;
}
.group-content{
    background: #f7f7f9;
    padding: 20px 20px 10px;
    border-radius: 8px;
}
 .w360 .el-input{
        width: 360px !important;
    }
</style>
<style lang="scss">
.el-dialog__wrapper .el-dialog.j-dialog{
  margin-bottom: 0!important;
}
.el-dialog__wrapper .el-dialog.j-dialog .el-dialog__body{
  max-height: 700px;
  overflow: auto;
  padding:10px 20px;
  .dialog-footer{
      border-top:0;
      margin-top: 0px;
      margin-bottom:20px;
  }
}
.el-form.el-form-edit .el-form-item.insured-info .el-form-item__content{
  position: relative;
  .btn_insured_myself{
    color: #e60012;;
    font-size: 12px;
    cursor: pointer;
    display: inline-block;
    height: 22px;
    line-height: 16px;
    &:hover{
      text-decoration: underline;
    }
  }
}
</style>
<style lang="scss">
   .j-dialog ::v-deep .el-form-item {
      width: 200px !important;
      .el-form-item__label{
        width: 180px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    .area-code {
      min-width: 50px !important;
      max-width: 115px !important;
      .el-button {
        text-align: left;
      }
    }
</style>
